export default function WorkflowAnimation() {
  return (
    <div className="workflow-visual" aria-hidden="true">
      <svg viewBox="0 0 1280 430" focusable="false">
        <defs>
          <linearGradient id="workflow-surface" x1="0" y1="0" x2="1" y2="1">
            <stop stopColor="#171522" />
            <stop offset="1" stopColor="#0b0d13" />
          </linearGradient>
          <linearGradient id="workflow-accent" x1="0" y1="0" x2="1" y2="1">
            <stop stopColor="#d9ceff" />
            <stop offset=".55" stopColor="#9b7ff1" />
            <stop offset="1" stopColor="#6f4edc" />
          </linearGradient>
          <linearGradient id="workflow-gold" x1="0" y1="0" x2="1" y2="1">
            <stop stopColor="#ffe1aa" />
            <stop offset="1" stopColor="#d89542" />
          </linearGradient>
          <radialGradient id="workflow-aura">
            <stop stopColor="#8f70eb" stopOpacity=".34" />
            <stop offset="1" stopColor="#8f70eb" stopOpacity="0" />
          </radialGradient>
          <pattern id="workflow-grid" width="28" height="28" patternUnits="userSpaceOnUse">
            <path d="M28 0H0v28" fill="none" stroke="#b9a6ff" strokeOpacity=".08" />
          </pattern>
          <filter id="workflow-glow" x="-100%" y="-100%" width="300%" height="300%">
            <feGaussianBlur stdDeviation="7" result="blur" />
            <feMerge><feMergeNode in="blur" /><feMergeNode in="SourceGraphic" /></feMerge>
          </filter>
        </defs>

        <rect x="1" y="1" width="1278" height="428" rx="34" fill="url(#workflow-surface)" stroke="#ffffff" strokeOpacity=".11" />
        <rect x="1" y="1" width="1278" height="428" rx="34" fill="url(#workflow-grid)" />
        <ellipse cx="640" cy="215" rx="500" ry="250" fill="url(#workflow-aura)" opacity=".45" />

        <path className="workflow-route" d="M366 216C440 216 449 216 517 216M764 216C837 216 850 216 914 216" fill="none" stroke="#ae95ff" strokeOpacity=".25" strokeWidth="2" strokeDasharray="7 10" />
        <circle className="workflow-pulse pulse-one" cx="366" cy="216" r="5" fill="#e8ddff" filter="url(#workflow-glow)" />
        <circle className="workflow-pulse pulse-two" cx="764" cy="216" r="5" fill="#e8ddff" filter="url(#workflow-glow)" />

        <g className="workflow-phase workflow-phase-1">
          <rect x="56" y="72" width="310" height="286" rx="22" fill="#10121a" stroke="#ffffff" strokeOpacity=".16" />
          <circle cx="78" cy="93" r="4" fill="#f0a66a" /><circle cx="92" cy="93" r="4" fill="#eac46f" /><circle cx="106" cy="93" r="4" fill="#72d7aa" />
          <rect x="72" y="119" width="112" height="14" rx="7" fill="#ffffff" fillOpacity=".11" />
          <g className="workflow-template template-a">
            <rect x="72" y="154" width="128" height="82" rx="12" fill="#211c34" stroke="#ab91ff" strokeOpacity=".7" />
            <rect x="84" y="166" width="104" height="28" rx="7" fill="url(#workflow-accent)" opacity=".72" />
            <rect x="84" y="204" width="68" height="6" rx="3" fill="#fff" fillOpacity=".6" />
            <rect x="84" y="216" width="46" height="5" rx="2.5" fill="#fff" fillOpacity=".22" />
          </g>
          <g className="workflow-template template-b">
            <rect x="216" y="154" width="128" height="82" rx="12" fill="#171923" stroke="#ffffff" strokeOpacity=".12" />
            <rect x="228" y="166" width="104" height="28" rx="7" fill="url(#workflow-gold)" opacity=".72" />
            <rect x="228" y="204" width="76" height="6" rx="3" fill="#fff" fillOpacity=".5" />
            <rect x="228" y="216" width="54" height="5" rx="2.5" fill="#fff" fillOpacity=".2" />
          </g>
          <rect x="72" y="254" width="272" height="86" rx="12" fill="#151721" />
          <rect x="88" y="270" width="112" height="54" rx="9" fill="#202334" />
          <rect x="214" y="270" width="114" height="8" rx="4" fill="#fff" fillOpacity=".48" />
          <rect x="214" y="288" width="86" height="6" rx="3" fill="#fff" fillOpacity=".17" />
          <rect x="214" y="306" width="64" height="15" rx="7.5" fill="#9f83f2" />
          <path className="workflow-cursor" d="M173 185l8 25 6-8 9 8 5-5-9-8 9-5-28-7Z" fill="#fff" stroke="#171221" strokeWidth="2" />
        </g>

        <g className="workflow-phase workflow-phase-2">
          <rect x="462" y="52" width="354" height="326" rx="22" fill="#10121a" stroke="#ffffff" strokeOpacity=".16" />
          <rect x="478" y="68" width="78" height="294" rx="13" fill="#151724" />
          <rect x="492" y="88" width="50" height="8" rx="4" fill="#d6c8ff" fillOpacity=".75" />
          <rect x="492" y="118" width="50" height="34" rx="8" fill="#a184f2" fillOpacity=".24" stroke="#aa8eff" strokeOpacity=".55" />
          <rect x="492" y="166" width="50" height="34" rx="8" fill="#202331" />
          <rect x="492" y="214" width="50" height="34" rx="8" fill="#202331" />
          <rect x="572" y="68" width="228" height="294" rx="14" fill="#f1eee9" />
          <rect x="590" y="87" width="192" height="20" rx="8" fill="#15131c" />
          <rect x="590" y="124" width="192" height="104" rx="12" fill="#d9ab59" />
          <circle cx="686" cy="176" r="34" fill="#211b2b" fillOpacity=".83" />
          <path d="M675 158h24v7h-16v7h14v6h-14v8h17v7h-25v-35Z" fill="#d7c9ff" />
          <rect x="590" y="245" width="142" height="11" rx="5.5" fill="#191721" />
          <rect x="590" y="267" width="184" height="7" rx="3.5" fill="#24222d" fillOpacity=".45" />
          <rect x="590" y="282" width="152" height="7" rx="3.5" fill="#24222d" fillOpacity=".3" />
          <rect x="590" y="311" width="78" height="25" rx="12.5" fill="#8d6de7" />
          <rect className="workflow-selection" x="582" y="116" width="208" height="120" rx="14" fill="none" stroke="#8d6de7" strokeWidth="3" strokeDasharray="8 6" />
          <circle className="workflow-handle" cx="790" cy="116" r="6" fill="#f5eaff" stroke="#8d6de7" strokeWidth="3" />
        </g>

        <g className="workflow-phase workflow-phase-3">
          <rect x="914" y="72" width="310" height="286" rx="22" fill="#10121a" stroke="#ffffff" strokeOpacity=".16" />
          <g className="workflow-nodes" fill="#1f2130" stroke="#aa90f5" strokeOpacity=".5">
            <rect x="940" y="105" width="72" height="38" rx="10" /><rect x="940" y="171" width="72" height="38" rx="10" /><rect x="940" y="237" width="72" height="38" rx="10" />
            <rect x="1052" y="138" width="72" height="38" rx="10" /><rect x="1052" y="220" width="72" height="38" rx="10" />
          </g>
          <g fill="none" stroke="#a98ef4" strokeOpacity=".45" strokeWidth="2">
            <path d="M1012 124l40 33M1012 190l40-33M1012 190l40 49M1012 256l40-17M1124 157l36 48M1124 239l36-34" />
          </g>
          <path className="workflow-package" d="M1159 182h35l15 15v76a12 12 0 0 1-12 12h-38a12 12 0 0 1-12-12v-79a12 12 0 0 1 12-12Z" fill="url(#workflow-accent)" />
          <path d="M1169 238l10 10 20-24" fill="none" stroke="#151221" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
          <rect x="940" y="300" width="264" height="30" rx="15" fill="#171925" />
          <rect className="workflow-progress" x="949" y="309" width="246" height="12" rx="6" fill="url(#workflow-gold)" />
        </g>
      </svg>
    </div>
  );
}
